const PUBLIC_URL = (process.env.PUBLIC_URL || '').replace(/\/$/, '');

export const assetUrl = (assetPath) => {
  if (!assetPath) {
    return '';
  }

  if (/^(?:https?:)?\/\//.test(assetPath) || assetPath.startsWith('data:')) {
    return assetPath;
  }

  const normalizedPath = assetPath.startsWith('/') ? assetPath : `/${assetPath}`;
  return `${PUBLIC_URL}${normalizedPath}`;
};

export const DEFAULT_CARD_IMAGE = assetUrl('/images/tavernix-logo.png');
export const DEFAULT_SERVICE_ICON = assetUrl('/images/enterprise.png');
